@if (loaded()) {
    @switch (view()) {
        @case ('details') {
            <end-customer-details
                [allowNavigation]="allowNavigation()"
                (updated)="onUpdated($event)"
            />
        }
        @case ('directory') {
            <end-customer-directory />
        }
    }
}
